import { formatDate, isValidDate, parseDate } from "data/lib/dates"
import { isValidNumber, localizeNum, tryParseFloat } from "data/lib/numbers"
import _ from "lodash"
import moment from "moment"
import { InputText } from "primereact/inputtext"
import React from "react"

type DateString = string
type DateEditInputProps = {
  rowData: object
  field: string
  persist: (value: DateString|null, field: string, rowData: object) => void
  withoutDays?: boolean
  className?: string
  allowRelative?: boolean
  disabled?: boolean
  endOfMonth?: boolean
}

const format = (format, withoutDays) => s =>
  formatDate(parseDate(s), format, withoutDays)

const DateEdit = (props: DateEditInputProps) => {
  const _format = format(
    props.withoutDays ? "MM/YYYY" : "MM/DD/YYYY",
    props.withoutDays
  )
  let initialValue = ""
  let propValue = _.get(props.rowData, props.field)
  if(propValue && isValidDate(propValue)) initialValue = _format(propValue)
  if(propValue && props.allowRelative && isValidNumber(propValue)) initialValue = localizeNum(propValue)

  let placeholder = ""
  if(props.withoutDays) {
    if(props.allowRelative) placeholder = "MM/YYYY or # of mos"
    else placeholder = "MM/YYYY"
  } else {
    if(props.allowRelative) placeholder = "MM/DD/YYYY or # of mos"
    else placeholder = "MM/DD/YYYY"
  }

  const format_and_persist = value => {
    if(isValidDate(value)) {
      if(props.endOfMonth && (
        moment(value, "MM/YY", true).isValid() ||
        moment(value, "M/YY", true).isValid())) {
        const date = moment(value, "MM/YY")
        const lastDayOfMonth = date.endOf("month")
        const val = lastDayOfMonth.format("YYYY-MM-DD")
        props.persist(val, props.field, props.rowData)
      } else {
        const val = format("YYYY-MM-DD", props.withoutDays)(value)
        props.persist(val, props.field, props.rowData)
      }
    } else if(isValidNumber(value)) {
      const parsed = tryParseFloat(value)
      props.persist(parsed, props.field, props.rowData)
    } else if (value === ""){
      props.persist(null, props.field, props.rowData)
    }
  }

  return (
    <InputText
      type="text"
      className={props.className}
      defaultValue={initialValue}
      disabled={props.disabled}
      onKeyDown={e => {
        switch(e.key) {
          case "Enter":
            format_and_persist((e.target as HTMLInputElement).value)
            break
          case "Tab":
            format_and_persist((e.target as HTMLInputElement).value)
            break
        }
      }}
      onBlur={e => format_and_persist((e.target as HTMLInputElement).value)}
      placeholder={placeholder}/>
  )
}

export default DateEdit
